import React from 'react';
import { BasicButton, IBasicButtonProps } from 'src/design/atoms/BasicButton';

export type IModalButtonProps = IBasicButtonProps;

const DefaultProps: Partial<IModalButtonProps> = {
  size: 'sm',
  variant: 'filled',
  color: 'blue',
};

/** @registry Filled blue button sized for modal footers/actions. */
export const ModalButton = React.forwardRef<
  HTMLButtonElement,
  IModalButtonProps
>(({ children, ...props }, ref) => {
  return (
    <BasicButton {...DefaultProps} {...props} ref={ref}>
      {children}
    </BasicButton>
  );
});
ModalButton.displayName = 'ModalButton';
